"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ddpReducer = exports.queriesReducer = exports.subscriptionsReducer = exports.entitiesReducer = exports.currentUserReducer = exports.statusReducer = void 0;
const omit_1 = __importDefault(require("lodash/omit"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const redux_actions_1 = require("redux-actions");
const redux_1 = require("redux");
const actions_1 = require("./actions");
exports.statusReducer = (0, redux_actions_1.handleActions)({
    [actions_1.setConnected]: (state, { payload }) => (Object.assign(Object.assign({}, state), { connected: !!payload })),
    [actions_1.setRestoring]: (state, { payload }) => (Object.assign(Object.assign({}, state), { restoring: !!payload })),
}, {
    connected: false,
    restoring: false,
});
exports.currentUserReducer = (0, redux_actions_1.handleActions)({
    [actions_1.setLoggingIn]: (state, { payload = true }) => (Object.assign(Object.assign({}, state), { isLoggingIn: !!payload })),
    [actions_1.setUser]: (state, { payload }) => (Object.assign(Object.assign({}, state), { isLoggingIn: false, 
        // eslint-disable-next-line no-underscore-dangle
        userId: payload._id, user: Object.assign(Object.assign({}, state.user), payload) })),
    [actions_1.clearUser]: (state) => (Object.assign(Object.assign({}, state), { isLoggingIn: false, userId: '', user: null })),
}, {
    userId: '',
    user: null,
    isLoggingIn: false,
});
exports.entitiesReducer = (0, redux_actions_1.handleActions)({
    [actions_1.replaceEntities]: (state, { payload }) => payload,
}, {});
exports.subscriptionsReducer = (0, redux_actions_1.handleActions)({
    [actions_1.createSubscription]: (state, _a) => {
        var _b = _a.payload, { id } = _b, fields = __rest(_b, ["id"]);
        return (Object.assign(Object.assign({}, state), { [id]: fields }));
    },
    [actions_1.updateSubscription]: (state, _a) => {
        var _b = _a.payload, { id } = _b, fields = __rest(_b, ["id"]);
        return (Object.assign(Object.assign({}, state), { [id]: Object.assign(Object.assign({}, state[id]), fields) }));
    },
    [actions_1.deleteSubscription]: (state, { payload: { id } }) => (0, omit_1.default)(state, [id]),
    [actions_1.setRestoring]: (state, { payload }) => {
        if (payload === false) {
            return (0, mapValues_1.default)(state, (subscription) => {
                if (subscription.pendingReady) {
                    const { pendingReady } = subscription, other = __rest(subscription, ["pendingReady"]);
                    return Object.assign(Object.assign({}, other), { ready: true });
                }
                return subscription;
            });
        }
        return state;
    },
}, {});
exports.queriesReducer = (0, redux_actions_1.handleActions)({
    [actions_1.createQuery]: (state, _a) => {
        var _b = _a.payload, { id } = _b, fields = __rest(_b, ["id"]);
        return (Object.assign(Object.assign({}, state), { [id]: fields }));
    },
    [actions_1.updateQuery]: (state, _a) => {
        var _b = _a.payload, { id } = _b, fields = __rest(_b, ["id"]);
        return (Object.assign(Object.assign({}, state), { [id]: Object.assign(Object.assign({}, state[id]), fields) }));
    },
    [actions_1.deleteQuery]: (state, { payload: { id } }) => (0, omit_1.default)(state, [id]),
}, {});
exports.ddpReducer = (0, redux_1.combineReducers)({
    status: exports.statusReducer,
    entities: exports.entitiesReducer,
    queries: exports.queriesReducer,
    subscriptions: exports.subscriptionsReducer,
    currentUser: exports.currentUserReducer,
});
//# sourceMappingURL=reducers.js.map